import dayjs from "../../../utils/dayjs";
import {
  daysJsFormat,
  iconSwitchStatusControl,
  renderUserName,
  roles,
  statusControl,
  statusPrestationsValues,
  typeSwitchStatusControl,
} from "../../../utils/constants";
import { Alert, Button, Checkbox, Col, notification, Row, Space } from "antd";
import React, { useContext, useState } from "react";
import {
  ActionRoleSpecific,
  UserCanDoActionMemo,
  UserHasLevel,
} from "../../../engine/AuthRoute";
import {
  confirmManuelPrestation,
  confirmValidateDraftPrestation,
  interpreteAcceptModification,
  interpreteRefuseModification,
  modalAnswerPrestationInvitation,
} from "../../../shared/components/Modals/modals";
import {
  getPrestation,
  postAnswerChangeApprovedRefused,
  postAppelInterpretes,
  postInterpretesAnswer,
  postManuelPrestation,
} from "../Slices/Prestation.slice";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../engine/context/User.context";
import { FiCheckCircle } from "react-icons/fi";
import { GiCancel } from "react-icons/gi";
import routes from "../../../engine/routes";
import { BsCheckLg, BsSendCheck } from "react-icons/bs";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { http } from "../../../engine/api/http";
import { useTranslation } from "react-i18next";
import { FaCheck, FaCheckDouble, FaExclamationTriangle } from "react-icons/fa";
import { MdOutlineDangerous } from "react-icons/md";
import { RenderUpdatedCopy } from "../../../shared/components/RenderUpdatedCopy/RenderUpdatedCopy";
import { RenderDate } from "./PrestationResumeCards";
import PDFdoc from "../../../assets/Tariffario - Condizioni Generali_2024_AVIC.pdf";
export const RenderStatusInterprete = ({ statusInterprete }) => {
  const { t } = useTranslation();

  if (
    statusInterprete === undefined ||
    statusInterprete?.answer === undefined
  ) {
    return null;
  } else {
    let date;

    if (statusInterprete?.answer) {
      date = dayjs(statusInterprete?.acceptedAt).format(daysJsFormat.full);
      return (
        <Alert
          message={`${t("prestationResumeActions.youAcceptedOn")} ${date}`}
          type="success"
          showIcon
          closable={true}
        />
      );
    } else {
      date = dayjs(statusInterprete?.refusedAt).format(daysJsFormat.full);
      return (
        <Alert
          message={`${t("prestationResumeActions.youRefusedOn")} ${date}`}
          type="warning"
          showIcon
          closable={true}
        />
      );
    }
  }
};

export const RenderNeedApprovalAlert = ({ toApproved, status }) => {
  const { t } = useTranslation();

  const latestModification = toApproved.sort((a, b) => {
    // Parse the date strings to make sure we're comparing them as dates
    const dateA = new Date(a.value.changeAt);
    const dateB = new Date(b.value.changeAt);

    // Sort in descending order, so the latest date comes first
    return dateB - dateA;
  })[0];

  if (
    status === statusPrestationsValues.waiting ||
    status === statusPrestationsValues.refused ||
    status === statusPrestationsValues.noReply ||
    status === statusPrestationsValues.cancel ||
    status === statusPrestationsValues.draft
  ) {
    return null;
  }

  return (
    toApproved.some(e => e.value?.needsApproval) && (
      <Col span={24}>
        <Alert
          message={`${t(
            "prestationResumeActions.interpreterMustApproveChanges",
          )} ${latestModification !== undefined &&
            dayjs(latestModification.value.changeAt).format(
              daysJsFormat.full,
            )}`}
          type="warning"
          showIcon
          closable={true}
        />
      </Col>
    )
  );
};

export const RenderApprovalButtons = ({
  toApproved,
  statusInterprete,
  elementsRef,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );
  const { user } = useContext(UserContext);
  const dispatch = useDispatch();

  if (
    statusInterprete === undefined ||
    statusInterprete.answer === false ||
    prestation.status !== statusPrestationsValues.planned ||
    prestation.interprete._id !== user._id ||
    toApproved.length === 0
  ) {
    return null;
  }


  const handleClick = () => {
    Object.entries(elementsRef.current).forEach(([key, ref]) => {
      if (toApproved.find(e => e.key === key)?.value?.needsApproval === true) {
        const offset = 100; // Replace with your desired offset value.
        const position = ref.offsetTop - offset;
        window.scrollTo({
          top: position,
          behavior: "smooth",
        });

        ref.classList.add("shake"); // Add the shake class
        ref.classList.add("hightlight-update"); // Add the shake class

        setTimeout(() => {
          ref.classList.remove("shake"); // Remove the shake class after 1 second
        }, 1000);
      }
    });
  };

  return (
    <>
      <ActionRoleSpecific only={roles.interprete}>
        <Col md={12} xs={24}>
          <Button
            onClick={() =>
              interpreteAcceptModification({
                onOk: () => {
                  dispatch(postAnswerChangeApprovedRefused(true));
                },
              })
            }
            size={"large"}
            className={"confirmButton"}
            type={"primary"}
            icon={<FiCheckCircle size={20} />}
          >
            {t("prestationResumeActions.approveChanges")}
          </Button>
        </Col>
        <Col md={12} xs={24}>
          <Button
            onClick={() =>
              interpreteRefuseModification({
                onOk: () => {
                  dispatch(postAnswerChangeApprovedRefused(false));
                },
              })
            }
            size={"large"}
            className={"confirmButton"}
            icon={<GiCancel size={20} />}
          >
            {t("prestationResumeActions.refuseChanges")}
          </Button>
        </Col>
        <Col md={12} xs={24}>
          <Button onClick={handleClick} style={{ marginLeft: 0 }}>
            {t("prestationResumeActions.highlightChanges")}
          </Button>
        </Col>
      </ActionRoleSpecific>
    </>
  );
};

export const RenderButtonsInterpreteAcceptRefuse = ({}) => {
  const { t } = useTranslation();
  const { user } = useContext(UserContext);

  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const answerYes = () => {
    const invitationToken = searchParams.get("invitation");

    modalAnswerPrestationInvitation({
      onOk: async () => {
        const res = await http.get("/prestations/" + prestation._id);

        if (res.data.interprete !== null) {
          notification.error({
            message:
              "Navré, un interprète vient d'accepter la prestation avant vous.",
            duration: 5000,
          }); // TODO TRANSLATION
          dispatch(getPrestation(prestation._id));
        } else {
          dispatch(
            postInterpretesAnswer({
              answer: true,
              invitationToken,
              interpreteId: user._id,
            }),
          );
        }
      },
    }).then(r => {});
  };

  const answerNo = () => {
    const invitationToken = searchParams.get("invitation");
    dispatch(
      postInterpretesAnswer({
        answer: false,
        invitationToken,
        interpreteId: user._id,
      }),
    );
  };

  if (prestation.status !== statusPrestationsValues.waiting) {
    return null;
  }

  return (
    <ActionRoleSpecific only={roles.interprete}>
      <Col md={12} xs={24}>
        <Button
          onClick={answerYes}
          size={"large"}
          className={"confirmButton"}
          type={"primary"}
          icon={<AiOutlineCheckCircle size={20} />}
        >
          {t("prestationResumeActions.acceptPrestation")}
        </Button>
      </Col>
      <Col md={12} xs={24}>
        <Button
          onClick={answerNo}
          size={"large"}
          className={"confirmButton"}
          icon={<GiCancel size={20} />}
        >
          {t("prestationResumeActions.refusePrestation")}
        </Button>
      </Col>
    </ActionRoleSpecific>
  );
};

export const RenderButtonDraftToNextStage = () => {
  const { t } = useTranslation();
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );

  const [tarif, setTarif] = useState(true);

  const { status } = prestation;
  const dispatch = useDispatch();

  const { id } = useParams();
  const finishDraftToNextStage = () => {
    const { status, interprete } = prestation;

    if (
      interprete !== null &&
      (status === statusPrestationsValues.draft ||
        status === statusPrestationsValues.waiting)
    ) {
      confirmManuelPrestation({
        onOk: () => {
          dispatch(postManuelPrestation());
        },
        onCancel: () => {},
      }).then(r => {});
    } else {
      confirmValidateDraftPrestation({
        onOk: () => {
          dispatch(postAppelInterpretes());
        },
        onCancel: () => {},
      }).then(r => {});
    }
  };

  return status === statusPrestationsValues.draft && !loading ? (
    <Space direction={"vertical"} style={{ width: "100%" }}>
      {/*<Checkbox style={{ width: "100%" }} onChange={() => setTarif(!tarif)}>*/}
      {/*  {t("prestationResumeActions.iAcceptTheTariffConditions")}*/}

      {/*  <a href={PDFdoc} target={"_blank"}>*/}
      {/*    {t("prestationResumeActions.seeConditionsWithThisLink")}*/}
      {/*  </a>*/}
      {/*</Checkbox>*/}
      <UserCanDoActionMemo
        route={routes.prestations(id).detailResume}
        action={"c"}
      >
        <Button
          style={{ flex: 1, width: "100%", fontWeight: 600 }}
          size={"large"}
          type={"dashed"}
          danger
          onClick={finishDraftToNextStage}
          loading={loadingAppel}
          disabled={!tarif}
        >
          <BsSendCheck
            style={{
              marginRight: 10,
              color: colorPrimary,
              marginTop: -2,
              opacity: tarif ? 1 : 0.3,
            }}
            size={20}
          />
          {t("prestationResumeActions.validateOrder")}
        </Button>
      </UserCanDoActionMemo>
      <br />
    </Space>
  ) : null;
};

export const RenderCancelAt = () => {
  const { t } = useTranslation();
  const { prestation, loading, loadingAppel } = useSelector(
    state => state.prestation,
  );

  const { cancel: { cancelNote = "", cancelAt } = {} } = prestation;

  let date = dayjs(cancelAt).format(daysJsFormat.full);

  return (
    prestation.status === statusPrestationsValues.cancel && (
      <Col span={24}>
        <Alert
          message={`${t(
            "prestationResumeActions.prestationCancelledOn",
          )} ${date}`}
          description={
            <>
              {cancelNote !== "" ? <b>{cancelNote}</b> : undefined}

              {prestation.interventionFinal.startDate !== null && (
                <>
                  <br />
                  <br />
                  <Row>
                    <Col
                      span={12}
                      // ref={elem =>
                      //   registerRef("interventionFinal.startDate", elem)
                      // }
                    >
                      <span className={"resume-subtitle"}>
                        {t("prestationResumeActions.dateStartReal")}
                      </span>
                      <RenderUpdatedCopy
                        changesKey={"interventionFinal.startDate"}
                        data={{
                          "interventionFinal.startDate":
                            prestation.interventionFinal.startDate,
                        }} // newStartDate should contain the updated date
                      >
                        <RenderDate />
                      </RenderUpdatedCopy>
                    </Col>
                    <Col
                      span={12}
                      // ref={elem => registerRef("interventionFinal.endDate", elem)}
                    >
                      <span className={"resume-subtitle"}>
                        {t("prestationResumeActions.dateEndReal")}
                      </span>
                      <RenderUpdatedCopy
                        changesKey={"interventionFinal.endDate"}
                        data={{
                          "interventionFinal.endDate":
                            prestation.interventionFinal.endDate,
                        }} // newStartDate should contain the updated date
                      >
                        <RenderDate />
                      </RenderUpdatedCopy>
                    </Col>
                  </Row>
                </>
              )}
            </>
          }
          type="warning"
          showIcon
          closable={true}
        />
      </Col>
    )
  );
};

export const RenderCommentAdmin = () => {
  const { t } = useTranslation();
  const { prestation } = useSelector(state => state.prestation);

  const { comment: { admin = "" } = {} } = prestation;

  if (admin?.length > 0) {
    return (
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <Col span={24}>
          <Alert
            className={"non-printable"}
            message={t("prestationResumeActions.adminComment")}
            description={admin}
            type="success"
            showIcon
            closable={true}
          />
        </Col>
      </ActionRoleSpecific>
    );
  } else {
    return null;
  }
};

export const RenderControl1 = () => {
  const { t } = useTranslation();
  const { prestation } = useSelector(state => state.prestation);

  const { control1 } = prestation;

  if (
    control1 !== undefined &&
    control1.status !== undefined &&
    control1.status !== statusControl.uncontrolled
  ) {
    return (
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <Col span={24}>
          <Alert
            icon={iconSwitchStatusControl(control1.status, 1)}
            message={`${t("prestationResumeActions.firstControlOn")} ${dayjs(
              control1.at,
            ).format(daysJsFormat.full)}, ${t(
              "prestationResumeActions.by",
            )} ${renderUserName(control1.user)}`}
            description={
              <>
                {control1.note} {}
              </>
            }
            type={typeSwitchStatusControl(control1.status)}
            showIcon
            closable={true}
          />
        </Col>
      </ActionRoleSpecific>
    );
  } else {
    return null;
  }
};
export const RenderControl2 = () => {
  const { t } = useTranslation();
  const { prestation } = useSelector(state => state.prestation);

  const { control2 } = prestation;

  if (
    control2 !== undefined &&
    control2.status !== undefined &&
    control2.status !== statusControl.uncontrolled
  ) {
    return (
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <Col span={24}>
          <Alert
            icon={iconSwitchStatusControl(control2.status, 2)}
            message={`${t("prestationResumeActions.secondControlOn")} ${dayjs(
              control2.at,
            ).format(daysJsFormat.full)}, ${t(
              "prestationResumeActions.by",
            )} ${renderUserName(control2.user)}`}
            description={
              <>
                {control2.note} {}
              </>
            }
            type={typeSwitchStatusControl(control2.status)}
            showIcon
            closable={true}
          />
        </Col>
      </ActionRoleSpecific>
    );
  } else {
    return null;
  }
};
